import classnames from 'classnames';
import { forwardRef } from 'react';

import {
  BaseCheckerInput,
  type BaseCheckerInputProps,
} from './BaseCheckerInput';

import styles from './scss/RadioInput.module.scss';

export interface RadioInputProps extends BaseCheckerInputProps {
  name?: string;
}

/** @deprecated Use `@/core/tamagoshiTailwind/components/Radio/Radio` instead */
export const RadioInput = forwardRef<HTMLInputElement, RadioInputProps>(
  (props, ref) => (
    <BaseCheckerInput
      {...props}
      type="radio"
      ref={ref}
      rootClassName={classnames(styles.radio, props.rootClassName)}
      labelClassName={classnames(styles.label, props.labelClassName)}
      inputClassName={classnames(styles.input, props.inputClassName)}
    />
  ),
);

RadioInput.displayName = 'RadioInput';
